import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";

interface PageHeaderProps {
  className?: string;
  SubTitle?: string;
  Title?: string;
  Icon?: string;
  Back?: boolean;
  Print?: boolean;
  AddButtonText?: string;
  AddonClickFunction?: () => void;
}

const PageHeader = ({
  className,
  SubTitle,
  Title,
  Icon,
  Back = true, // ✅ default here
  Print = false, // ✅ default here
  AddButtonText,
  AddonClickFunction,
}: PageHeaderProps) => {
  const goBack = () => window.history.back();
  const printPage = () => window.print();
  const handleAddClick = () => AddonClickFunction?.();

  return (
    <div
      className={
        "p-16 px-lg-40 py-lg-24 mx-n24 mt-n24 mx-lg-n40 mt-lg-n40 mb-24 mb-lg-32 border-bottom d-flex gap-8 gap-lg-16 align-items-center justify-content-between " +
        className
      }
    >
      {!Back || (
        <Button
          variant="link"
          className="d-print-none d-inline-block bg-white rounded-circle p-8 lh-1 shadow-sm"
          onClick={goBack}
        >
          <span className="bi bi-arrow-left"></span>
        </Button>
      )}
      {!Icon || <span className={"text-blue fs-3 bi bi-" + Icon}></span>}
      <div className="w-100 overflow-hidden">
        <span className="smaller text-uppercase fw-bold text-muted">
          {SubTitle}
        </span>
        <h1 className="h4 m-0 text-truncate">{Title}</h1>
      </div>
      {!Print || (
        <Button
          variant="outline-blue"
          className="d-print-none px-16"
          onClick={printPage}
        >
          <span className="bi bi-printer"></span>
        </Button>
      )}
      {!AddButtonText || (
        <Button
          variant="primary"
          onClick={handleAddClick}
          className="d-print-none px-16 d-flex gap-8 text-nowrap"
        >
          <span className="bi bi-plus-lg"></span>
          <span className="d-none d-lg-block">{AddButtonText}</span>
        </Button>
      )}
    </div>
  );
};

export default PageHeader;
export { PageHeader };
export type { PageHeaderProps };
